var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPendingSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(74,50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#FF8C6A"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "8;5;5",
    begin: "-0.9s"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.41640786499875,64.10684605501936)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#FF8C6A"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "8;5;5",
    begin: "-0.8s"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.41640786499874,72.82535639108369)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#FF8C6A"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "8;5;5",
    begin: "-0.7s"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.58359213500126,72.82535639108369)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#FF8C6A"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "8;5;5",
    begin: "-0.6s"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.583592135001265,64.10684605501936)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#FF8C6A"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "8;5;5",
    begin: "-0.5s"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26,50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#FF8C6A"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "8;5;5",
    begin: "-0.4s"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.58359213500126,35.89315394498065)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#FF8C6A"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "8;5;5",
    begin: "-0.3s"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.58359213500126,27.174643608916316)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#FF8C6A"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "8;5;5",
    begin: "-0.2s"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.41640786499873,27.174643608916313)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#FF8C6A"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "8;5;5",
    begin: "-0.1s"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.41640786499873,35.89315394498064)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 6,
    fill: "#FF8C6A"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.3;1",
    dur: "1s",
    repeatCount: "indefinite",
    values: "8;5;5",
    begin: "0s"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingSpinner);
export default __webpack_public_path__ + "static/media/pending-spinner.b86a7df6.svg";
export { ForwardRef as ReactComponent };